// extracted by mini-css-extract-plugin
export default {"clickableHeader":"clickableHeader_clickableHeader__4B4ck"};